import { fromJS } from 'immutable';

/**
 * Holds a local copy a courseware config, thus caching it.
 * Most of the methods are normal Map collection methods,
 * with the exception of getIn and setIn, which allows the use
 * of a path parameter.
 */
class PreviewScope {
  constructor() {
    this._scope = fromJS({});
  }

  get() {
    return this._scope.toJS();
  }

  getIn(path) {
    if (this._scope.getIn(path)) {
      const scope = this._scope.getIn(path) instanceof Object ? this._scope.getIn(path).toJS() : this._scope.getIn(path);
      return scope;
    }
  }

  setIn(path, obj) {
    this._scope = this._scope.setIn(path, fromJS(obj));
  }
}
export default PreviewScope;
